/**
 * Bread's standard slide: how panes, panels and inline content slide open and
 * closed. Components that slide use these so they all move the same way.
 */
export const RYE_SLIDE_MS = 260;
export const RYE_SLIDE_EASING = "cubic-bezier(0.22, 1, 0.36, 1)";

/**
 * Plays a one-off slide on an element with the standard timing, e.g. text
 * gliding into place. Does nothing when reduced motion is requested.
 */
export function animateRyeSlide(
  element: Element | null | undefined,
  keyframes: Keyframe[],
): void {
  if (
    !element ||
    window.matchMedia?.("(prefers-reduced-motion: reduce)").matches
  ) {
    return;
  }
  element.animate?.(keyframes, {
    duration: RYE_SLIDE_MS,
    easing: RYE_SLIDE_EASING,
  });
}
